import { render, staticRenderFns } from "./Attempts.vue?vue&type=template&id=5d8b49f2&"
import script from "./Attempts.vue?vue&type=script&lang=js&"
export * from "./Attempts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports